//
//
//
//

export default {
  props: ["name","size","inline","color","notextshadow"],
  computed: {
    computedName() {
      return this.name || "defaultIcon";
    },
    computedSize() {
      return (this.size) ? `m-${this.size}` : "m-medium";
    },
    computedInline() {
      return (this.inline == "") ? "m-inline" : "";
    },
    computedColor() {
      return this.color || "inherit";
    },
    computedClass() {
      return `${this.computedName} ${this.computedSize} ${this.computedInline}`.replace(/\s+$/, ""); 
    }
  }
}



// WEBPACK FOOTER //
// ./components/globalBlocks/Icon.vue